import {
  DropDownQuestionConfig,
  DropDownSingleChoiceComposedElement,
} from '@hyper-inferno/drop-down-single-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  BaseComposedElement,
  QuestionAnswerObject,
  QuestionType,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class DropDownSingleChoiceHandler
  implements QuestionHandler<DropDownQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    const key = el.name;
    return [(response[key] as number) ?? 0];
  }

  handleAutoCode(
    el: SurveyElement,
    ctx: ITransformationContext,
    composedElement: BaseComposedElement,
  ): QuestionAnswerObject | null {
    const config = (composedElement as DropDownSingleChoiceComposedElement)[
      QuestionType.DROP_DOWN_SINGLE_CHOICE
    ] as DropDownQuestionConfig | undefined;

    if (!config) return null;

    const options = config.options ?? [];

    // Exclude AFM placeholders and hidden or disabled options.
    const selectableOptions = options.filter(
      (option) => !option.is_afm_trigger && !option.hidden && !option.disabled,
    );

    // No selectable options: save an empty answer.
    if (selectableOptions.length === 0) {
      return {};
    }

    // Auto-code when exactly one selectable option remains.
    if (selectableOptions.length === 1) {
      const onlyOption = selectableOptions[0];

      // Open-ended options require respondent input.
      if (onlyOption.is_open_ended) {
        return null;
      }

      return {
        [el.name]: onlyOption.option_key,
      };
    }

    // Multiple selectable options require respondent input.
    return null;
  }
}
